export const TENANT_ID_STORAGE_KEY = 'tenant-id';
